var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStayInformedBgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1224,
    height: 137,
    viewBox: "0 0 1224 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1331.86 -59.0466C1277.01 -58.5953 1218.16 -62.7662 1164.24 -55.9306C1078.72 -45.0888 1000.14 -19.5269 915.59 -6.53867C883.366 -1.57508 853.738 0.638412 822.403 -7.41065C795.561 -14.3072 772.803 -26.1857 751.423 -37.9849C713.826 -58.7173 673.294 -87.4074 620.189 -91.9136C586.397 -94.7857 553.074 -83.8158 524.595 -74.035C492.69 -63.059 462.513 -50.3695 430.628 -39.3996C401.31 -29.3139 366.719 -17.905 331.928 -21.3807C301.831 -24.393 275.688 -36.9117 253.389 -48.8207C210.5 -71.6874 164.585 -108.286 101.075 -104.884C26.0914 -100.871 -29.9391 -61.8395 -106.081 -59.0833",
    stroke: "url(#paint0_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.84 -52.1495C1276.61 -51.7165 1217.79 -56.9911 1163.49 -49.808C1079.93 -38.7649 1003.64 -12.9408 921.072 0.273035C888.718 5.45004 859.649 7.39523 828.054 -0.42212C800.733 -7.17846 777.126 -18.7154 754.918 -30.3012C715.753 -50.6617 673.803 -78.9371 620.548 -84.2726C587.155 -87.6142 554.422 -77.1199 526.222 -67.4062C495.016 -56.6497 465.608 -44.07 434.422 -33.3013C405.213 -23.2095 371.291 -12.3677 336.71 -16.2276C306.473 -19.6119 279.791 -32.0818 256.824 -43.8261C213.076 -66.1867 165.523 -101.664 102.353 -98.2793C26.9097 -94.2364 -29.5502 -54.9424 -106.152 -52.1679",
    stroke: "url(#paint1_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.83 -45.3868C1276.15 -45.0454 1217.35 -51.5883 1162.56 -44.0941C1081.1 -32.9535 1007.23 -6.89772 926.794 6.38932C894.46 11.7432 865.791 13.4079 834.036 5.93198C806.225 -0.617031 781.79 -11.7516 758.673 -22.9837C717.731 -42.8807 674.502 -70.4792 621.048 -76.5831C556.539 -83.9553 491.352 -45.5882 439.076 -27.5022C409.977 -17.4286 376.974 -7.33682 342.692 -11.5626C312.215 -15.3249 284.974 -27.6729 261.218 -39.2404C216.361 -61.0765 167.031 -95.285 104.021 -91.8825C28.0185 -87.7848 -28.9808 -48.2041 -106.131 -45.387",
    stroke: "url(#paint2_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.81 -38.7652C1275.64 -38.5762 1216.83 -46.5216 1161.47 -38.7652C1082.19 -27.6185 1010.88 -1.44075 932.676 11.889C900.452 17.377 872.062 18.7429 840.217 11.6999C811.898 5.42533 786.613 -5.21529 762.588 -16.0937C719.868 -35.4237 675.351 -62.1014 621.627 -68.9614C558.097 -77.0593 495.716 -39.8019 444.409 -22.0086C416.039 -12.1851 382.966 -2.2823 349.623 -7.34345C318.667 -12.0387 291.395 -23.4233 266.291 -35.0091C220.146 -56.2903 168.919 -89.1146 105.908 -85.6755C29.2571 -81.4985 -28.3513 -41.6191 -106.151 -38.7226",
    stroke: "url(#paint3_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.79 -32.2709C1275.09 -32.2709 1216.22 -41.7407 1160.24 -33.6978C1083.22 -22.6303 1014.52 3.65718 938.627 16.9137C806.814 39.9572 738.052 -45.1129 622.266 -61.3939C559.854 -70.1808 500.628 -34.2649 450.25 -16.8314C422.01 -7.07496 390.215 1.80948 357.292 -3.53827C325.946 -8.62991 298.036 -19.7644 271.923 -31.1307C224.34 -51.8631 171.125 -83.1935 107.985 -79.6995C30.6246 -75.431 -27.6628 -35.2406 -106.181 -32.271",
    stroke: "url(#paint4_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.77 -25.9165C1274.52 -26.1726 1215.55 -37.1974 1158.9 -28.9166C1084.18 -17.9955 1018.1 8.35299 944.578 21.4937C815.491 44.5555 736.873 -36.4352 622.954 -53.8809C561.621 -63.2837 505.95 -28.9593 456.49 -11.8612C428.37 -2.14133 397.963 5.57235 365.509 -0.0193156C333.744 -5.50732 305.125 -16.3613 277.963 -27.4898C228.853 -47.6124 173.611 -77.4367 110.201 -73.8634C32.082 -69.4669 -26.9343 -28.9838 -106.212 -25.9166",
    stroke: "url(#paint5_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.75 -19.697C1273.93 -20.2154 1214.85 -32.8499 1157.49 -24.3618C1085.05 -13.642 1021.68 12.737 950.431 25.7009C824.08 48.6956 735.735 -27.8681 623.664 -46.4785C563.429 -56.4789 511.543 -23.8436 462.952 -7.08083C434.931 2.58414 406.032 9.05998 374.078 3.28538C341.873 -2.56239 312.515 -13.1786 284.275 -24.0327C233.587 -43.5455 176.308 -71.8148 112.578 -68.1623C33.6901 -63.6316 -26.105 -22.8436 -106.172 -19.6728",
    stroke: "url(#paint6_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.73 -13.6116C1273.35 -14.3982 1214.1 -28.6487 1155.98 -19.9838C1085.78 -9.50782 1025.03 16.8833 956.073 29.6277C832.408 52.4882 734.617 -19.4777 624.383 -39.204C565.237 -49.7898 517.245 -18.8924 469.483 -2.45276C441.582 7.15124 414.091 12.3526 382.666 6.37071C350.012 0.150972 319.885 -10.1969 290.586 -20.7827C238.311 -39.6858 179.015 -66.3941 114.886 -62.65C35.1686 -57.9913 -25.3657 -16.9167 -106.231 -13.6117",
    stroke: "url(#paint7_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.71 -7.6664C1272.79 -8.71522 1213.34 -24.5451 1154.55 -15.7338C1086.51 -5.53221 1028.32 20.8529 961.566 33.3472C840.348 56.0309 733.489 -11.2519 625.043 -32.0819C566.975 -43.2409 522.888 -14.0813 475.904 2.06556C448.124 11.6086 421.981 15.5355 391.154 9.38288C358.051 2.78509 327.165 -7.32502 296.818 -17.6181C243.004 -35.8748 181.731 -61.0769 117.163 -57.2536C36.6468 -52.4669 -24.6362 -11.0569 -106.29 -7.67874",
    stroke: "url(#paint8_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.69 -1.84852C1272.18 -3.14735 1212.59 -20.4955 1153.08 -11.5623C1087.09 -1.65341 1031.36 24.7134 966.678 36.9394C847.786 59.4158 732.38 -3.19618 625.751 -25.1299C568.652 -36.8742 528.509 -9.33056 482.175 6.49316C454.484 15.9447 429.709 18.6887 399.402 12.3592C365.87 5.38335 334.234 -4.52554 302.899 -14.5198C247.607 -32.1485 184.447 -55.8688 119.429 -51.948C38.1542 -47.0393 -23.8479 -5.33048 -106.251 -1.84866",
    stroke: "url(#paint9_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.67 3.82873C1271.61 2.31648 1211.84 -16.4586 1151.67 -7.43387C1087.56 2.17621 1034.13 28.543 971.391 40.4824C910.527 52.0682 845.779 38.9885 788.929 25.0123C734.107 11.5302 681.991 -6.15339 626.35 -18.3794C569.97 -30.7701 534.011 -4.5253 488.026 10.8899C426.962 31.3479 364.421 5.40187 308.53 -11.4219C251.901 -28.4469 186.963 -50.7526 121.515 -46.7463C39.5217 -41.734 -23.1594 0.267506 -106.292 3.8347",
    stroke: "url(#paint10_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.65 9.37719C1271.03 7.6881 1211.25 -12.3858 1150.31 -3.29401C1087.91 6.02339 1036.61 32.3719 975.555 44.0491C915.251 55.5983 848.795 43.0551 791.676 30.2559C735.745 17.7189 682.511 1.16342 626.88 -11.8614C571.248 -24.8863 538.754 0.0719044 493.359 15.2676C433.683 35.2378 368.536 7.34043 313.614 -8.30037C255.796 -24.7644 189.21 -45.7163 123.403 -41.6552C40.7704 -36.5514 -22.5298 5.73058 -106.271 9.37705",
    stroke: "url(#paint11_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.63 14.7854C1270.44 12.956 1210.71 -8.23982 1149.06 0.906835C1088.15 9.93763 1038.74 36.2739 979.3 47.7255C919.455 59.2198 851.482 47.1889 794.103 35.4507C737.184 23.7978 682.881 8.23631 627.339 -5.58735C601.136 -12.1059 581.934 -12.3742 556.6 -3.96535C536.009 2.87026 518.593 12.7974 498.033 19.6818C470.601 28.8773 448.752 28.6212 420.023 21.7855C385.502 13.5596 351.87 4.10199 317.998 -5.08736C259.211 -20.9904 191.178 -40.7228 125.071 -36.6251C41.8692 -31.4664 -21.9602 11.0961 -106.301 14.7852",
    stroke: "url(#paint12_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.61 20.067C1269.85 18.2376 1210.3 -3.97047 1147.93 5.20667C1088.23 13.9936 1040.5 40.4274 982.266 51.5863C922.73 62.9953 853.508 51.4644 795.9 40.6103C738.291 29.7563 682.98 14.9997 627.618 0.364988C602.035 -6.39745 583.331 -7.3548 558.217 1.01134C538.305 7.64572 521.689 17.4387 501.827 24.1219C474.545 33.3051 453.036 32.3295 424.806 25.2683C390.115 16.5911 355.963 7.15178 321.452 -1.78146C261.927 -17.1844 192.565 -35.8193 126.359 -31.7094C42.6976 -26.5202 -21.5613 16.2984 -106.311 20.0119",
    stroke: "url(#paint13_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.59 25.2007C1269.25 23.4201 1210.04 0.443721 1146.97 9.64526C1088.15 18.237 1041.92 44.8721 984.492 55.7017C925.036 66.9277 855.065 55.9212 797.098 45.8416C738.66 35.6888 682.869 21.5481 627.738 6.10849C602.673 -0.903948 584.179 -2.37961 559.255 5.98653C539.882 12.4807 523.935 22.2127 504.622 28.7678C477.471 37.9815 455.981 36.4876 428.181 29.1581C393.44 20.0114 358.889 10.5476 323.848 1.80344C263.933 -13.1544 193.413 -30.8258 127.257 -26.7464C43.2663 -21.5633 -21.3022 21.4992 -106.412 25.2006",
    stroke: "url(#paint14_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.57 30.207C1268.66 28.5911 1209.96 5.05976 1146.19 14.2857C1087.99 22.7067 1042.75 49.4576 986.01 60.1592C926.744 71.3303 855.855 60.5617 797.737 51.1101C738.701 41.5061 682.66 27.7495 627.788 11.4746C603.133 4.15723 584.539 2.38888 559.744 10.8099C540.771 17.2552 525.323 26.9934 506.38 33.4997C479.328 42.7927 457.539 41.0366 430.068 33.3717C395.397 23.7006 360.587 14.1697 325.157 5.57188C265.062 -9.0079 193.723 -25.8865 127.837 -21.8681C43.6462 -16.7399 -21.0821 26.5543 -106.391 30.2069",
    stroke: "url(#paint15_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.54 35.085C1268.31 33.6337 1210.02 9.84624 1145.86 19.1575C1087.86 27.5725 1042.89 54.299 986.33 64.9396C927.124 76.0741 855.915 65.086 797.778 55.8356C738.532 46.4085 682.671 32.7555 627.729 16.4074C603.164 9.09006 584.31 7.56562 559.685 15.9318C540.842 22.3344 525.494 31.9872 506.65 38.4082C479.689 47.5914 457.5 45.884 430.289 37.9996C395.768 27.9992 360.917 18.3952 325.337 9.88275C265.532 -4.42873 193.265 -21.1183 127.887 -16.9475C43.8165 -11.5936 -21.3311 30.9688 -106.421 35.0665",
    stroke: "url(#paint16_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.52 39.8842C1268.15 38.5061 1210.03 14.5602 1145.72 23.9812C1087.81 32.4693 1042.61 58.9703 986.01 69.5438C926.804 80.6051 855.755 69.1352 797.707 59.8239C738.651 50.348 683.03 36.7194 627.708 21.1457C575.342 6.4074 549.389 29.0728 506.26 43.2075C479.299 52.0431 456.97 50.4333 430.008 42.5184C395.637 32.4266 360.846 22.847 325.277 14.432C265.821 0.370566 192.615 -16.3983 127.707 -11.8738C43.9956 -6.03212 -21.9509 34.7986 -106.471 39.7926",
    stroke: "url(#paint17_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.5 44.6104C1267.94 43.281 1209.96 19.1582 1145.45 28.6586C1087.54 37.1954 1042.16 63.4159 985.531 73.8918C926.325 84.8678 855.486 72.9589 797.528 63.6171C738.701 54.135 683.29 40.5675 627.649 25.7804C575.722 11.975 548.841 34.238 505.682 47.7323C478.72 56.1839 456.192 54.6228 429.47 46.6957C395.258 36.549 360.567 27.0426 325.008 18.774C265.792 4.99912 191.857 -11.5929 127.488 -6.76351C44.1959 -0.519394 -22.5595 38.5369 -106.461 44.3236",
    stroke: "url(#paint18_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.48 49.2506C1267.7 47.9578 1209.81 23.6399 1145.06 33.1829C1087.22 41.7076 1041.57 67.6292 984.902 77.9954C925.696 88.7885 855.086 76.5807 797.238 67.2329C738.691 57.7813 683.399 44.3174 627.558 30.3474C576.001 17.4628 548.201 39.2319 504.932 52.0982C477.9 60.1289 455.203 58.5679 428.68 50.6469C394.659 40.4819 360.038 31.0852 324.538 23.0118C265.472 9.56615 191.087 -6.61734 127.158 -1.5379C44.2751 5.04159 -23.2492 42.2624 -106.511 48.7626",
    stroke: "url(#paint19_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.46 53.812C1267.41 52.5315 1209.63 28.0245 1144.55 37.5736C1086.76 46.0495 1040.83 71.6785 984.112 81.8374C924.926 92.4414 854.676 79.9592 796.848 70.6418C738.62 61.2512 683.498 47.9276 627.428 34.7991C576.261 22.817 547.481 44.0128 504.013 56.184C476.891 63.7818 454.014 62.1659 427.661 54.2693C393.905 44.0527 359.267 34.9617 323.898 27.0366C264.882 13.963 190.288 -1.62296 126.728 3.6882C44.3846 10.536 -23.9686 45.8787 -106.502 52.9948",
    stroke: "url(#paint20_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.43 58.2871C1267.09 57.0066 1209.33 32.2862 1143.94 41.8231C1086.19 50.2319 1039.95 75.5194 983.164 85.471C923.998 95.8372 854.047 83.1599 796.329 73.8852C738.411 64.5922 683.439 51.4514 627.239 39.1766C576.451 28.0787 546.633 48.6465 502.905 60.0798C475.654 67.2081 452.606 65.5007 426.404 57.6407C392.851 47.4917 358.339 38.5712 323.05 30.9263C264.004 18.2612 189.419 3.52289 126.199 8.97429C44.3851 16.0294 -24.7469 49.4391 -106.561 57.1101",
    stroke: "url(#paint21_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.41 62.6662C1266.74 61.3795 1208.99 36.4457 1143.23 45.9095C1085.52 54.2146 1038.96 79.1362 982.146 88.85C923.01 98.9601 853.429 86.1303 795.761 76.9349C738.272 67.7882 683.32 54.8548 627.06 43.452C576.631 33.226 545.715 53.0926 501.687 63.7515C474.286 70.3859 451.059 68.5504 424.966 60.7026C391.643 50.6507 357.286 41.9308 322.112 34.598C262.966 22.4024 188.611 8.64585 125.66 14.2253C44.4156 21.4207 -25.4652 52.8608 -106.54 61.0013",
    stroke: "url(#paint22_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.39 66.959C1266.36 65.6419 1208.56 40.4703 1142.42 49.8852C1084.75 58.0441 1037.85 82.5693 980.977 92.0208C921.881 101.838 852.679 88.9171 795.141 79.8253C738.052 70.8006 683.16 58.1599 626.879 47.6351C576.8 38.275 544.726 57.3915 500.369 67.2333C472.798 73.3311 449.391 71.3554 423.378 63.5747C390.275 53.6419 356.061 45.1549 320.993 38.1774C261.657 26.4514 187.722 13.8595 125.001 19.5365C44.3452 26.8538 -26.2548 56.2512 -106.571 64.8125",
    stroke: "url(#paint23_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.37 71.1535C1265.95 69.7997 1208.16 44.3842 1141.53 53.6711C1083.9 61.708 1036.63 85.8186 979.699 94.9774C920.652 104.472 851.88 91.5078 794.421 82.5319C737.732 73.6718 682.889 61.3482 626.659 51.7137C576.92 43.1768 543.617 61.5128 498.91 70.507C471.15 76.0865 447.563 73.8974 421.61 66.2386C388.739 56.4564 354.687 48.2287 319.754 41.6279C260.189 30.4385 186.853 19.1454 124.311 24.8895C44.2547 32.2069 -27.0142 59.5858 -106.571 68.5008",
    stroke: "url(#paint24_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.35 75.2454C1265.52 73.8429 1207.68 48.1835 1140.62 57.3423C1082.96 65.1902 1035.32 88.8861 978.321 97.7279C919.335 106.875 851.042 93.9168 793.583 85.075C737.313 76.4039 682.51 64.434 626.34 55.6959C576.94 48.0066 542.339 65.4889 497.263 73.5928C469.303 78.6174 445.546 76.2149 419.613 68.5927C386.981 58.9823 353.099 51.0421 318.317 44.854C258.521 34.2378 185.924 24.335 123.523 30.1462C44.0955 37.5062 -27.8126 62.751 -106.611 71.9708",
    stroke: "url(#paint25_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.33 79.2146C1265.09 77.7694 1207.18 51.8661 1139.53 60.8725C1081.96 68.5435 1033.92 91.776 976.863 100.282C917.946 109.069 850.122 96.142 792.794 87.477C736.933 79.0133 682.17 67.4397 626.12 59.5919C577.029 52.7136 541.06 69.3483 495.635 76.5193C467.475 80.9768 443.529 78.3486 417.585 70.7813C385.2 61.3631 351.5 53.7328 316.888 47.9817C256.703 37.9813 185.005 29.6274 122.703 35.4263C43.8952 42.7437 -28.5821 65.8664 -106.631 75.3485",
    stroke: "url(#paint26_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.31 83.1181C1264.6 81.5876 1206.57 55.4342 1138.44 64.2699C1080.89 71.7275 1032.42 94.4966 975.325 102.649C916.459 111.046 849.144 98.1918 791.895 89.6732C736.454 81.4229 681.731 70.2884 625.831 63.3308C577.03 57.233 539.643 72.9714 493.878 79.185C465.508 83.0571 441.382 80.1484 415.399 72.6848C383.26 63.4778 349.747 56.1777 315.321 50.8852C254.767 41.5434 184.067 34.7932 121.845 40.5982C43.6559 47.8851 -29.3406 68.8004 -106.651 78.502",
    stroke: "url(#paint27_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.29 86.8918C1264.1 85.282 1205.97 58.8786 1137.28 67.5191C1079.77 74.7572 1030.92 97.0445 973.718 104.825C914.931 112.826 848.136 100.063 790.977 91.7334C735.935 83.7148 681.283 73.0498 625.561 66.9825C577.01 61.6957 538.175 76.4828 492.061 81.7696C463.491 85.0441 439.196 81.8488 413.123 74.4522C381.234 65.4742 347.915 58.5267 313.694 53.7198C252.78 45.0853 183.159 40.012 120.967 45.7927C43.3867 52.9941 -30.0691 71.7021 -106.671 81.5988",
    stroke: "url(#paint28_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.27 90.5508C1263.61 88.8556 1205.33 62.2022 1136.11 70.6354C1078.59 77.6417 1029.33 99.4352 972.061 106.832C913.354 114.411 847.088 101.777 789.969 93.6423C735.316 85.8554 680.744 75.7026 625.202 70.5195C576.861 66.0132 536.548 79.8369 490.104 84.148C461.325 86.8249 436.859 83.3248 410.687 76.038C379.046 67.2921 345.922 60.7033 311.916 56.3909C250.593 48.5065 182.16 45.1649 119.989 50.9029C43.0976 58.0129 -30.7976 74.4647 -106.69 84.526",
    stroke: "url(#paint29_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.25 94.0933C1263.1 92.3067 1204.67 65.4338 1134.88 73.6109C1077.36 80.3733 1027.69 101.673 970.353 108.667C911.726 115.801 845.999 103.325 788.95 95.3982C734.667 87.8552 680.194 78.2451 624.892 73.9401C576.721 70.19 534.94 83.0319 488.196 86.3674C459.237 88.4345 434.582 84.6173 408.309 77.4219C376.914 68.9249 343.991 62.7133 310.218 58.9152C248.506 51.8234 181.281 50.2441 119.109 55.9394C42.7776 62.9275 -31.4073 77.1048 -106.641 87.3125",
    stroke: "url(#paint30_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.23 97.5081C1262.58 95.63 1203.98 68.4827 1133.63 76.4464C1076.12 82.9649 1026.01 103.752 968.605 110.313C910.078 117.021 844.901 104.685 787.862 96.9775C733.938 89.6602 679.585 80.6416 624.513 77.2085C576.431 74.2084 533.223 86.0503 486.119 88.404C456.951 89.8614 432.196 85.7088 405.674 78.611C374.521 70.3671 341.798 64.541 308.272 61.2689C167.471 47.0672 29.4969 71.0253 -106.78 89.9284",
    stroke: "url(#paint31_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.21 100.814C1262.05 98.8318 1203.28 71.4467 1132.35 79.1604C1074.84 85.4167 1024.31 105.686 966.827 111.863C908.4 118.143 843.772 105.96 786.853 98.4781C733.239 91.4108 679.045 82.9775 624.223 80.4348C576.151 78.1847 531.584 88.9716 484.132 90.3741C454.793 91.2278 429.829 86.7155 403.157 79.7213C372.36 71.593 339.657 66.4099 306.454 63.5439C169.238 51.6959 26.1211 73.6906 -106.751 92.4656",
    stroke: "url(#paint32_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.19 103.985C1261.52 101.899 1202.57 74.2763 1131.07 81.7339C1073.55 87.7524 1022.59 107.479 965.04 113.241C906.713 119.077 842.644 107.058 785.785 99.826C732.46 93.027 678.457 85.1913 623.884 83.4778C575.722 81.9656 529.897 91.7342 482.085 92.1428C452.577 92.3928 427.453 87.5267 400.571 80.618C369.974 72.7579 337.49 68.0199 304.567 65.6662C241.846 61.1843 178.246 65.0015 116.044 70.4834C41.4098 77.0629 -33.3342 84.2827 -106.77 94.8745",
    stroke: "url(#paint33_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.17 107.027C1261.59 104.874 1202.72 77.2028 1131.28 84.0201C1074 89.5081 1022.94 108.466 965.839 114.216C908.121 120.027 845.34 108.497 788.98 101.533C734.497 94.8253 679.305 87.3311 623.534 86.3921C574.024 85.5567 525.783 94.7887 476.383 93.7094C446.565 93.0569 421.71 87.1055 394.379 80.4955C365.989 73.6294 336.012 69.6963 305.695 67.8365C241.166 63.879 177.167 69.7146 113.407 75.2209C39.8115 81.5748 -34.4433 86.4652 -106.821 97.0875",
    stroke: "url(#paint34_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.16 109.936C1261.1 107.68 1201.99 79.7765 1130.03 86.3316C1072.73 91.5513 1021.26 110.009 964.072 115.339C906.473 120.68 844.192 109.314 787.911 102.576C733.688 96.0758 678.706 89.1609 623.225 89.1609C573.425 89.1609 524.115 97.1672 474.306 95.1245C444.448 93.9049 419.384 87.612 391.843 81.1423C363.643 74.5201 333.865 71.0017 303.807 69.6114C239.069 66.6174 176.178 74.3189 112.429 79.6727C39.3124 85.8131 -34.9323 88.4291 -106.8 99.1856",
    stroke: "url(#paint35_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.14 112.704C1260.55 110.344 1201.33 82.2152 1128.75 88.5142C1071.43 93.49 1019.56 111.43 962.294 116.344C904.816 121.29 843.024 110.003 786.773 103.484C732.85 97.2218 678.077 90.9289 622.886 91.8192C572.727 92.6302 522.448 99.4353 472.219 96.4413C442.322 94.6546 417.057 88.0263 389.337 81.6969C361.376 75.3125 331.738 72.2087 301.961 71.2879C237.053 69.2696 175.2 78.8004 111.471 84.0079C38.8137 89.9471 -35.3213 90.2764 -106.77 101.167",
    stroke: "url(#paint36_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.12 115.332C1260.04 112.893 1200.57 84.5261 1127.48 90.5629C1070.15 95.3008 1017.89 112.753 960.526 117.228C903.168 121.704 841.875 110.57 785.774 104.277C731.98 98.2399 677.468 92.5385 622.576 94.3251C571.977 95.9715 520.84 101.557 470.192 97.624C440.234 95.3008 414.79 88.3127 386.81 82.1296C358.829 75.9464 329.571 73.2878 300.073 72.8244C235.165 71.7938 174.131 83.1113 110.472 88.1724C38.2339 93.9165 -35.841 91.9652 -106.81 103.014",
    stroke: "url(#paint37_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.11 117.82C1259.54 115.259 1199.86 86.7215 1126.25 92.4778C1068.89 96.9841 1016.25 113.905 958.809 118.003C901.61 122.082 840.697 111.021 784.696 104.942C731.062 99.1243 676.849 94.0205 622.226 96.6852C571.129 99.1792 519.232 103.551 468.135 98.6975C438.267 95.8559 412.524 88.502 384.343 82.4591C356.683 76.5321 327.424 74.2515 298.246 74.2332C233.338 74.1844 173.083 87.2336 109.513 92.1606C37.6151 97.734 -36.2802 93.5082 -106.81 104.734",
    stroke: "url(#paint38_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.1 120.155C1259.05 117.509 1199.19 88.7334 1125.05 94.2702C1067.67 98.5386 1014.64 115.003 957.132 118.661C899.993 122.32 839.688 111.344 783.678 105.478C730.154 99.8923 676.21 95.3617 621.907 98.8923C570.26 102.246 517.695 105.405 466.128 99.6484C436.27 96.3251 410.307 88.5992 381.917 82.6966C354.386 76.9768 325.377 75.1048 296.468 75.5195C231.66 76.4402 172.035 91.1602 108.555 95.9714C37.066 101.386 -36.6395 94.886 -106.84 106.338",
    stroke: "url(#paint39_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.08 122.345C1258.58 119.607 1198.51 90.6363 1123.88 95.9291C1066.47 100.009 1013.04 115.942 955.503 119.253C898.484 122.534 838.669 111.576 782.688 105.929C729.264 100.557 675.59 96.5938 621.597 100.972C569.371 105.204 516.156 107.167 464.23 100.527C434.402 96.7157 408.219 88.6239 379.58 82.8433C352.219 77.3553 323.36 75.843 294.7 76.6784C230.062 78.5504 170.946 94.868 107.576 99.5755C36.4264 104.862 -37.0594 96.1059 -106.92 107.783",
    stroke: "url(#paint40_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.07 124.381C1258.17 121.558 1197.88 92.3797 1122.78 97.4592C1065.33 101.35 1011.6 116.801 953.936 119.747C897.017 122.649 837.641 111.71 781.75 106.258C728.396 101.045 674.991 97.6786 621.317 102.886C568.482 108.008 514.789 108.801 462.413 101.301C432.645 97.0323 406.212 88.5746 377.383 82.9281C350.162 77.5986 321.463 76.4949 293.103 77.7267C228.694 80.5256 169.987 98.3493 106.737 102.996C35.8376 108.185 -37.3486 97.1847 -106.9 109.142",
    stroke: "url(#paint41_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.06 126.253C1257.7 123.363 1197.25 93.9896 1121.73 98.8678C1064.23 102.575 1010.18 117.57 952.447 120.155C895.618 122.698 836.701 111.758 780.861 106.478C727.556 101.435 674.411 98.6299 621.037 104.648C567.663 110.667 513.44 110.313 460.654 101.984C430.957 97.2945 404.264 88.5686 375.275 82.9464C348.314 77.7085 319.574 77.0499 291.564 78.678C227.415 82.3367 169.038 101.6 105.917 106.185C35.3274 111.313 -37.6491 98.0872 -106.901 110.368",
    stroke: "url(#paint42_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1331 127.997C1257.25 125.046 1196.66 95.4776 1120.69 100.167C1063.21 103.697 1008.84 118.241 951.04 120.491C894.34 122.698 835.803 111.722 780.022 106.594C726.748 101.716 673.853 99.4411 620.788 106.252C566.725 113.186 512.182 111.74 459.017 102.594C429.379 97.5081 402.457 88.4529 373.299 82.91C346.447 77.8062 317.857 77.5135 290.137 79.4709C259.89 81.6112 230.401 86.5138 201.362 91.953C170.027 97.813 137.783 106.752 105.139 109.118C34.7886 114.222 -37.9383 98.8008 -106.91 111.448",
    stroke: "url(#paint43_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1331 129.521C1256.89 126.521 1196.19 96.7642 1119.78 101.295C1062.25 104.71 1007.59 118.85 949.721 120.765C893.112 122.661 834.994 111.618 779.263 106.618C725.989 101.85 673.303 100.112 620.548 107.691C565.896 115.545 510.993 113.051 457.439 103.112C427.931 97.6239 400.78 88.2943 371.471 82.8307C344.729 77.8488 316.269 77.8854 288.818 80.1782C258.631 82.6905 229.313 88.0199 200.444 93.8067C169.338 100.039 137.044 109.441 104.41 111.826C34.2793 116.942 -38.218 99.3557 -106.921 112.435",
    stroke: "url(#paint44_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1331 130.906C1256.55 127.857 1195.69 97.9234 1118.95 102.32C1061.38 105.625 1006.46 119.339 948.543 120.979C892.013 122.583 834.285 111.412 778.594 106.539C725.31 101.887 672.814 100.637 620.368 108.979C565.087 117.741 509.935 114.265 456.001 103.564C426.603 97.7343 399.252 88.1181 369.794 82.7154C343.161 77.8372 314.872 78.1787 287.62 80.7702C257.503 83.6362 228.334 89.3681 199.615 95.472C168.719 102.039 136.385 111.857 103.751 114.277C33.8499 119.461 -38.4775 99.7343 -106.95 113.284",
    stroke: "url(#paint45_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1331 132.119C1256.24 129.07 1195.28 98.9289 1118.21 103.222C1060.57 106.435 1005.37 119.771 947.395 121.143C890.925 122.485 833.556 111.149 777.925 106.374C724.621 101.807 672.275 101.02 620.149 110.076C564.298 119.777 509.006 115.387 454.693 103.978C425.395 97.813 397.864 87.9468 368.286 82.5929C341.743 77.794 313.553 78.4038 286.562 81.2697C256.484 84.4649 227.475 90.5627 198.886 96.9593C168.16 103.844 135.805 113.996 103.132 116.472C33.3706 121.765 -38.7771 99.9472 -106.95 114.033",
    stroke: "url(#paint46_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1331 133.155C1255.95 130.106 1194.93 99.776 1117.56 104.002C1059.92 107.148 1004.46 120.13 946.436 121.289C890.026 122.393 833.037 110.856 777.406 106.148C724.071 101.636 671.825 101.27 619.999 111.026C563.569 121.655 508.247 116.435 453.535 104.319C424.366 97.8552 396.675 87.7634 366.988 82.4461C340.525 77.702 312.475 78.5435 285.673 81.6534C255.635 85.1474 226.756 91.5744 198.287 98.2393C167.7 105.404 135.376 115.819 102.612 118.362C33.001 123.819 -39.0568 99.9467 -106.961 114.654",
    stroke: "url(#paint47_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1331 134.022C1256.32 130.974 1195.5 100.643 1118.58 104.576C1057.8 107.68 999.042 121.699 937.709 121.412C885.273 121.168 832.657 110.65 780.861 106.125C725.829 101.32 673.154 101.454 619.859 111.741C560.763 123.12 505.391 117.138 448.432 103.607C422.898 97.5455 398.573 89.2769 372.849 83.5999C345.628 77.5936 315.74 78.1789 287.73 81.5144C255.945 85.295 225.518 92.4904 195.541 99.8077C165.324 107.21 133.199 117.632 100.615 120.071C31.7129 125.199 -39.9455 99.8809 -106.95 115.15",
    stroke: "url(#paint48_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1331 134.705C1256.11 131.699 1195.29 101.167 1118.16 105.106C1057.36 108.216 998.333 121.906 937.019 121.448C884.624 121.052 832.278 110.241 780.511 105.71C725.439 100.893 672.774 101.368 619.739 112.326C560.044 124.668 504.962 117.985 447.533 103.789C422.119 97.5086 397.724 89.1668 371.931 83.4837C344.769 77.4713 315.011 78.1786 287.161 81.7031C255.396 85.7215 225.089 93.2279 195.201 100.74C165.024 108.326 132.909 118.863 100.246 121.424C31.4732 126.778 -40.2651 99.5635 -106.961 115.57",
    stroke: "url(#paint49_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1331 135.192C1255.96 132.235 1195.19 101.52 1117.84 105.521C1057.03 108.667 997.873 122.064 936.48 121.46C884.105 120.948 832.008 109.789 780.262 105.222C725.16 100.344 672.415 101.118 619.719 112.734C559.445 126.015 504.802 118.771 446.884 103.978C421.53 97.508 397.075 89.0809 371.262 83.3307C344.12 77.2878 314.622 78.05 286.791 81.7392C222.492 90.2761 164.884 117.003 99.9661 122.393C31.3134 128.094 -40.6146 99.0446 -106.961 115.856",
    stroke: "url(#paint50_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1331 135.503C1255.84 132.606 1195.09 101.709 1117.65 105.807C1056.83 109.032 997.474 122.167 936.111 121.466C883.725 120.856 831.859 109.307 780.132 104.66C725.01 99.7089 672.085 100.709 619.689 112.953C558.886 127.167 504.852 119.502 446.385 104.112C421.241 97.5076 396.725 88.7573 370.852 83.2327C343.371 77.3727 314.762 77.8484 286.632 81.7022C222.223 90.5317 164.934 117.283 99.7864 123.063C31.2236 129.161 -41.014 98.3369 -106.921 116.039",
    stroke: "url(#paint51_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1331 135.619C1255.76 132.808 1195.12 101.728 1117.6 105.978C1056.78 109.313 997.344 122.228 935.861 121.472C883.465 120.826 831.799 108.789 780.082 104.033C724.96 98.9654 671.756 100.13 619.669 112.99C558.396 128.131 505.122 120.192 446.096 104.216C392.172 89.6296 347.745 73.0254 286.682 81.5745C222.103 90.6175 165.084 117.143 99.7066 123.387C31.2237 129.93 -41.3934 97.4408 -107 116.07",
    stroke: "url(#paint52_linear_171872_90240)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171872_90240",
    x1: -1035340,
    y1: -10476.5,
    x2: -1035340,
    y2: -2830.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_171872_90240",
    x1: -1035370,
    y1: -10499.2,
    x2: -1035370,
    y2: -2831.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_171872_90240",
    x1: -1035350,
    y1: -10471.3,
    x2: -1035350,
    y2: -2819.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_171872_90240",
    x1: -1035350,
    y1: -10397.6,
    x2: -1035350,
    y2: -2795.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_171872_90240",
    x1: -1035360,
    y1: -10229,
    x2: -1035360,
    y2: -2746.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_171872_90240",
    x1: -1035370,
    y1: -10116.1,
    x2: -1035370,
    y2: -2712.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_171872_90240",
    x1: -1035320,
    y1: -9979.69,
    x2: -1035320,
    y2: -2672.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_171872_90240",
    x1: -1035350,
    y1: -9834.95,
    x2: -1035350,
    y2: -2630.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_171872_90240",
    x1: -1035380,
    y1: -9681.91,
    x2: -1035380,
    y2: -2586.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_171872_90240",
    x1: -1035340,
    y1: -9526.85,
    x2: -1035340,
    y2: -2541.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_171872_90240",
    x1: -1035350,
    y1: -9324.98,
    x2: -1035350,
    y2: -2484.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_171872_90240",
    x1: -1035320,
    y1: -9180.49,
    x2: -1035320,
    y2: -2443.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_171872_90240",
    x1: -1035330,
    y1: -9051.72,
    x2: -1035330,
    y2: -2405.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_171872_90240",
    x1: -1035320,
    y1: -8950.52,
    x2: -1035320,
    y2: -2375.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_171872_90240",
    x1: -1035380,
    y1: -8863.22,
    x2: -1035380,
    y2: -2348.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_171872_90240",
    x1: -1035350,
    y1: -8819.92,
    x2: -1035350,
    y2: -2333.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_171872_90240",
    x1: -1035350,
    y1: -8799.15,
    x2: -1035350,
    y2: -2324.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_171872_90240",
    x1: -1035370,
    y1: -8741.96,
    x2: -1035370,
    y2: -2306.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_171872_90240",
    x1: -1035350,
    y1: -8656.03,
    x2: -1035350,
    y2: -2279.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_171872_90240",
    x1: -1035370,
    y1: -8530.68,
    x2: -1035370,
    y2: -2243.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_171872_90240",
    x1: -1035350,
    y1: -8380.54,
    x2: -1035350,
    y2: -2200.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_171872_90240",
    x1: -1035370,
    y1: -8201.04,
    x2: -1035370,
    y2: -2149.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_171872_90240",
    x1: -1035350,
    y1: -8000.92,
    x2: -1035350,
    y2: -2092.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_171872_90240",
    x1: -1035350,
    y1: -7774.32,
    x2: -1035350,
    y2: -2029.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_171872_90240",
    x1: -1035340,
    y1: -7522.82,
    x2: -1035340,
    y2: -1959.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_171872_90240",
    x1: -1035350,
    y1: -7263.42,
    x2: -1035350,
    y2: -1887.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_171872_90240",
    x1: -1035350,
    y1: -6983.07,
    x2: -1035350,
    y2: -1810.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_171872_90240",
    x1: -1035350,
    y1: -6700.56,
    x2: -1035350,
    y2: -1732.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_171872_90240",
    x1: -1035350,
    y1: -6403.28,
    x2: -1035350,
    y2: -1650.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_171872_90240",
    x1: -1035350,
    y1: -6107.36,
    x2: -1035350,
    y2: -1569.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_171872_90240",
    x1: -1035300,
    y1: -5817.65,
    x2: -1035300,
    y2: -1489.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_171872_90240",
    x1: -1035390,
    y1: -5507.37,
    x2: -1035390,
    y2: -1405.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_171872_90240",
    x1: -1035350,
    y1: -5316.07,
    x2: -1035350,
    y2: -1352.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_171872_90240",
    x1: -1035350,
    y1: -5080.34,
    x2: -1035350,
    y2: -1287.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_171872_90240",
    x1: -1035370,
    y1: -4892.96,
    x2: -1035370,
    y2: -1236.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_171872_90240",
    x1: -1035350,
    y1: -4741.38,
    x2: -1035350,
    y2: -1194.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_171872_90240",
    x1: -1035320,
    y1: -4615.35,
    x2: -1035320,
    y2: -1160.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_171872_90240",
    x1: -1035330,
    y1: -4508.15,
    x2: -1035330,
    y2: -1130.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_171872_90240",
    x1: -1035320,
    y1: -4420.94,
    x2: -1035320,
    y2: -1106.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_171872_90240",
    x1: -1035340,
    y1: -4423.68,
    x2: -1035340,
    y2: -1106.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_171872_90240",
    x1: -1035380,
    y1: -4542.45,
    x2: -1035380,
    y2: -1137.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_171872_90240",
    x1: -1035360,
    y1: -4665.52,
    x2: -1035360,
    y2: -1168.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_171872_90240",
    x1: -1035350,
    y1: -4790.76,
    x2: -1035350,
    y2: -1201.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_171872_90240",
    x1: -1035320,
    y1: -4919.59,
    x2: -1035320,
    y2: -1234.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_171872_90240",
    x1: -1035320,
    y1: -5039,
    x2: -1035320,
    y2: -1266.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_171872_90240",
    x1: -1035350,
    y1: -5155.75,
    x2: -1035350,
    y2: -1296.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_171872_90240",
    x1: -1035350,
    y1: -5263.44,
    x2: -1035350,
    y2: -1324.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_171872_90240",
    x1: -1035350,
    y1: -5362.28,
    x2: -1035350,
    y2: -1350.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_171872_90240",
    x1: -1035350,
    y1: -5457.04,
    x2: -1035350,
    y2: -1375.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_171872_90240",
    x1: -1035350,
    y1: -5528.35,
    x2: -1035350,
    y2: -1394.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_171872_90240",
    x1: -1035350,
    y1: -5590.3,
    x2: -1035350,
    y2: -1410.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_171872_90240",
    x1: -1035320,
    y1: -5628.15,
    x2: -1035320,
    y2: -1420.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_171872_90240",
    x1: -1035380,
    y1: -5596.62,
    x2: -1035380,
    y2: -1412.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStayInformedBgTop);
export default __webpack_public_path__ + "static/media/stay_informed_bg_top.1836b0345a2ec260b2cf3dabfe626037.svg";
export { ForwardRef as ReactComponent };